<template>
    <div class="px-2">
        <div class="flex -mx-4">
            <div class="w-1/3 px-2">

                <template>
                    <form>
                        <vx-card
                            :title="product.id ? 'Edycja':'Dodaj nowy produkt'"
                            title-color="primary"
                            :subtitle="product.id ? 'Aktualizuj obecny produkt':'Nowy produkt trafi do Twojej bazy'">

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" label-placeholder="Nazwa produktu"
                                              v-model="product.name" v-validate="'required'" name="name"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('name')">{{ errors.first('name') }}</span>

                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" type="text" label-placeholder="Może zawierać"
                                              v-model="product.contains"
                                              name="contains"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('contains')">{{ errors.first('contains') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full ">
                                    <vs-input class="w-full" label-placeholder="Warunki przechowywania"
                                              v-model="product.keep" v-validate="''"
                                              name="keep"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('keep')">{{ errors.first('keep') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2" v-if="!isBestBefore">
                                    <flat-pickr v-model="product.best_before" placeholder="Data ważności"
                                                class="mt-5" :config="configdateTimePicker"
                                                :disabled="isBestBeforeDisabled"/>
                                </div>
                              <div class="vx-col w-full sm:w-1/2 w-full mb-2" v-if="!isBestBefore">
                                <select
                                    class="mt-5 h-10 vs-input--input"
                                    :disabled="isBestBeforeDisabled"
                                    v-model="best_before_days"
                                >
                                  <option disabled selected style="display: none" value="0" class="w-4/5">
                                    Data ważności w dniach
                                  </option>
                                  <option v-for="number in 90" :key="number" :value="number" class="w-4/5">
                                    {{ number }}
                                  </option>
                                </select>
                              </div>
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-checkbox v-model="isBestBefore" class="mt-8">Bez terminu</vs-checkbox>
                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full lg:w-full mb-2" v-if="!isBestBefore">
                                    <vs-checkbox v-model="product.best_before_batch" class="mt-2 float-left"></vs-checkbox>
                                    Termin przydatności jest równocześnie numerem partii produkcyjnej
                                </div>
                            </div>


                            <div class="vx-row mb-2">
                                <div class="vx-col w-full ">
                                    <vs-input class="w-full" label-placeholder="Producent"
                                              v-model="product.producer"
                                              name="producer"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('producer')">{{ errors.first('producer') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" label-placeholder="Waga jednego produktu"
                                              v-model="product.weight"
                                              type="number" name="weight"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('weight')">{{ errors.first('weight') }}</span>
                                </div>
                                <!--                SADASD ASDAS DAS DAS              -->
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <select v-model="product.unit" class="mt-5 h-10 vs-input--input">
                                        <option v-for="(key,item) in units" :value="item" class="w-4/5">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" label-placeholder="Pojemność opakowania (g)"
                                              v-model="product.weight_package"
                                              type="number" name="weight"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('weight_package')">{{ errors.first('weight_package') }}</span>
                                </div>

                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <select v-model="product.unit_package" class="mt-5 h-10 vs-input--input">
                                        <option v-for="(key,item) in units" :value="item" class="w-4/5">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>

                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full"
                                              label-placeholder="Utrata masy w wyniku obróbki cieplnej"
                                              v-model="product.weight_loss"
                                              type="number" name="weight_loss"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('weight_loss')">{{
                                            errors.first('weight_loss')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full"
                                              label-placeholder="Utrwalone metodą"
                                              v-model="product.fixing_method"
                                              type="string" name="weight_loss"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('fixing_method')">{{
                                            errors.first('fixing_method')
                                        }}</span>
                                </div>
                            </div>


                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-full w-full mb-2">
                                    <vs-input class="w-full" label-placeholder="Waga netto po odsączeniu (g)"
                                              v-model="product.weight_drainage"
                                              type="number" name="weight"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('weight_drainage')">{{ errors.first('weight_drainage') }}</span>
                                </div>

                            </div>


                            <div class="vx-row mb-2">
                                <div class="vx-col w-full ">
                                    <vs-input class="w-full" label-placeholder="Cena"
                                              v-model="product.price"
                                              type="number" name="price"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('price')">{{ errors.first('price') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full ">
                                    <vs-input class="w-full" label-placeholder="Kod EAN 8"
                                              v-model="product.ean_8"
                                              maxlength="8"
                                              v-validate="'numeric'"
                                              name="ean_8"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('ean_8')">{{ errors.first('ean_8') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" label-placeholder="Kod EAN 13"
                                              v-model="product.ean_13"
                                              maxlength="13"
                                              v-validate="'numeric'"
                                              name="ean_13"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('ean_13')">{{ errors.first('ean_13') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                    <vs-input
                                        class="w-full"
                                        label-placeholder="WNI"
                                        v-model="product.wni"
                                        maxlength="12"
                                        name="ean_13"/>
                                    <span class="text-danger text-sm"
                                        v-show="errors.has('wni')">{{ errors.first('wni') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2 mt-6">
                                <div class="vx-col w-full">
                                    <vs-textarea
                                        class="w-full vs-input--input"
                                        name="recipe"
                                        v-model="product.recipe"
                                        label="Notatki"
                                        label-placeholder="Notatki" />
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('recipe')">{{ errors.first('recipe') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-2 mt-6">
                                <div class="vx-col w-full">
                                    <vs-textarea class="w-full" name="recipe" v-model="product.preparing_method"
                                                 placeholder="Metoda przygotowania"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('preparing_method')">{{ errors.first('preparing_method') }}</span>
                                </div>
                            </div>


                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <vs-button class="mr-3 mb-2" @click.prevent="submitForm">
                                        {{ product.id ? 'Aktualizuj' : 'Dodaj' }}
                                    </vs-button>
                                    <vs-button color="warning" type="border" class="mb-2"
                                               @click="resetForm">Reset
                                    </vs-button>
                                </div>
                            </div>


                        </vx-card>
                    </form>
                </template>


                <template>
                    <vx-card title="Wartości odżywcze"
                             title-color="primary"
                             subtitle="w 100g produktu" class="mt-4">
                        <div class="mt-4">
                            <div class="flex justify-between">
                                <div class="flex flex-col">
                                    <span class="mb-1">Tłuszcze śr.</span>
                                </div>
                                <div class="flex flex-col text-right">
                                <span class="flex -mr-1">
                                    <span class="mr-1">{{ toWeight(summarized.fat) }}g</span>
                                </span>
                                </div>
                            </div>
                            <vs-progress :percent="(summarized.fat)"></vs-progress>
                        </div>
                        <div class="mt-4">
                            <div class="flex justify-between">
                                <div class="flex flex-col">
                                    <span class="mb-1">Węglowodany śr.</span>
                                </div>
                                <div class="flex flex-col text-right">
                                <span class="flex -mr-1">
                                    <span class="mr-1">{{ toWeight(summarized.carbohydrates) }}g</span>
                                </span>
                                </div>
                            </div>
                            <vs-progress :percent="(summarized.carbohydrates)"></vs-progress>
                        </div>
                        <div class="mt-4">
                            <div class="flex justify-between">
                                <div class="flex flex-col">
                                    <span class="mb-1">Białko śr.</span>
                                </div>
                                <div class="flex flex-col text-right">
                                <span class="flex -mr-1">
                                    <span class="mr-1">{{ toWeight(summarized.protein) }}g</span>
                                </span>
                                </div>
                            </div>
                            <vs-progress :percent="(summarized.protein)"></vs-progress>
                        </div>
                        <div class="mt-4">
                            <div class="flex justify-between">
                                <div class="flex flex-col">
                                    <span class="mb-1">Sól śr</span>
                                </div>
                                <div class="flex flex-col text-right">
                                    <span class="flex -mr-1">
                                        <span class="mr-1">{{ toWeight(summarized.sol) }}g</span>
                                    </span>
                                </div>
                            </div>
                            <vs-progress :percent="(summarized.sol)"></vs-progress>
                        </div>
                    </vx-card>
                </template>


            </div>
            <div class="w-2/3 px-2">
                <div class="bg-grid-color h-12">

                    <vx-card
                        title="Baza składników"
                        title-color="primary"
                        subtitle="Przeglądaj listę dostępnych składników ">

                        <vs-input class="w-1/2 mb-4" label-placeholder="Wyszukaj składnik"
                                  v-model="search" placeholder="Wyszukaj składnik"/>

                      <div class="mb-2">
                        <label for="ingredient-filter">filtr składników</label>
<!--                        <vs-select label="" v-model="ingredientFilter" @input="fetchIngredientsFiltered">-->
<!--                          <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in ingredientFilters" />-->
<!--                        </vs-select>-->
                        <select id="ingredient-filter" v-model="ingredientFilter" @change="fetchIngredientsFiltered" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                          <option v-for="item in ingredientFilters" :key="item.id" :value="item.id">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>

                        <vs-table max-items="10" stripe :data="ingredients">

                            <template slot="thead">
                                <vs-th>lp.</vs-th>
                                <vs-th>Nazwa produktu</vs-th>
                                <vs-th sort-key="calorific">kcal</vs-th>
                                <vs-th sort-key="protein">B</vs-th>
                                <vs-th sort-key="carbohydrates">W</vs-th>
                                <vs-th sort-key="fat">T</vs-th>
                                <vs-th>&nbsp;</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].id">
                                        {{ indextr + 1 }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].name">
                                        <vx-tooltip :text="getChildrenNames(data[indextr].children_ingredients)"
                                                    v-if="data[indextr].children_ingredients.length">
                                            {{ data[indextr].name }}
                                        </vx-tooltip>
                                        <span v-if="!data[indextr].children_ingredients.length">{{
                                                data[indextr].name
                                            }}</span>
                                    </vs-td>

                                    <vs-td :data="data[indextr].calorific">
                                        {{ data[indextr].calorific }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].protein">
                                        {{ data[indextr].protein }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].carbohydrates">
                                        {{ data[indextr].carbohydrates }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].fat">
                                        {{ data[indextr].fat }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].id" class="text-center">
                                        <div class="fonticon-wrap">
                                            <i v-on:click="addIngredient(data[indextr])"
                                               class="feather icon-plus-square"></i>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination class="mt-4" :total="ingredientsCount" :max="10" v-model="ingredientsPage"
                                       goto></vs-pagination>
                    </vx-card>

                    <vx-card
                        title="Skład"
                        title-color="primary"
                        subtitle="Skład obecnego produktu" class="mt-4">

                        <vs-table stripe :data="productIngredients">

                            <template slot="thead" class="flex">
                                <vs-th class="">Składnik</vs-th>
                                <vs-th class="w-1/4">Producent</vs-th>
                                <vs-th sort-key="calorific" class="w-1/5">Waga</vs-th>
                                <vs-th sort-key="calorific" class="w-1/5">Jednostka</vs-th>
                                <vs-th class="w-1/6">&nbsp;</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].name" class="w-2/5">
                                        {{ data[indextr].name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].producer" class="w-1/5">
                                        {{ data[indextr].producer }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].weight" class="w-1/5">
                                        <vs-input v-model="data[indextr].weight" class="flex-1 w-2/3"></vs-input>
                                    </vs-td>
                                    <vs-td class="w-2/5">
                                        <!--
                                        <vs-select :options="units" v-model="data[indextr].unit" class="flex-1 w-4/5">
                                                                                    <vs-select-item :key="item" :value="item" :text="item"
                                                                                                    v-for="(item,index) in units" class="w-4/5"/>
                                                                                </vs-select>-->
                                        <select v-model="productIngredients[indextr].unit"
                                                class="flex-1 w-4/5 vs-inputx vs-input--input">
                                            <option v-for="(key, item) in units" :value="item" class="w-4/5">
                                                {{ item }}
                                            </option>
                                        </select>

                                    </vs-td>

                                    <vs-td :data="data[indextr].id" class="text-center w-1/5">
                                        <div class="fonticon-wrap">
                                            <i v-on:click="removeIngredient(indextr)"
                                               class="feather icon-minus-square"></i>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>

                        </vs-table>
                    </vx-card>

                </div>
            </div>
        </div>
    </div>

</template>
<style>
.vs-component.vs-con-textarea.w-full.vs-input--input.vs-textarea-primary h4 {
  font-size: .9rem!important;
  font-weight: 400;
}

.focusx textarea {
  border-color: rgba(var(--vs-primary), 1)!important;
}
.focusx h4 {
  color: rgba(0,0,0,.4);
}
</style>
<script>
import {Validator} from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Polish as PolishLocale} from 'flatpickr/dist/l10n/pl.js';

import vSelect from 'vue-select'

const dict = {
    custom: {
        name: {
            required: 'Nazwa produktu jest wymagana',
        },
        weight: {
            required: 'Waga produktu jest wymagana',
        },
        cukry_proste: {
            required: 'Cukry są wymagany'
        },
        emulgatory: {
            required: 'Emulgatory są wymagany'
        },
        calorific: {
            required: 'Kaloryczność jest wymagana'
        },
        fat: {
            required: 'Tłuszcz jest wymagany'
        },
        protein: {
            required: 'Białko jest wymagane'
        },
        carbohydrates: {
            required: 'Węglowodany jest wymagany'
        },
        fat_saturated: {
            required: 'Tłuszcz nasycony jest wymagany'
        },
        roughage: {
            required: 'Błonnik jest wymagany'
        },
        sodium: {
            required: 'Sód jest wymagany'
        },
        sol: {
            required: 'Sól jest wymagana'
        },
        ean_8: {
            numeric: 'Kod EAN8 składa się wyłącznie z liczb'
        },
        ean_13: {
            numeric: 'Kod EAN13 składa się wyłącznie z liczb'
        }
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    data() {
        return {
            ingredientFilterIsLoading: false,
            ingredientFilter: -2,
            ingredientFilters: [
              {id: -2, name: 'Moje składniki'},
              {id: -3, name: 'Składniki globalne'}
              //{id: -4, name: 'Składniki wewnętrzne'},
            ],
            ingredientsPage: 1,
            ingredientsCount: 0,
            search: '',
            alert: false,
            alertType: 'alert-success',
            configdateTimePicker: {
                locale: PolishLocale
            },
            product: {
                id: null,
                name: '',
                contains: '',
                keep: '',
                best_before: '',
                best_before_batch:'',
                producer: '',
                weight: '',
                weight_drainage: '',
                weight_package: '',
                allergens: '',
                weight_loss: '',
                fixing_method: '',
                recipe: '',
                preparing_method:'',
                price: '',
                unit: 'g',
                unit_package: 'g',
                wni:''
            },
            productIngredients: [],
            preview: {
                protein: 0,
                carbohydrates: 0,
                fat: 0,
                cholesterol: 0,
                roughage: 0,
                sodium: 0
            },
            isBestBefore: false,
            isBestBeforeBatch: false,
            ingredients: [],
            brief: [],
            pi: [],
            units: {'g': 1, 'ml': 1},
            isLoading: false,
            ean_8: '',
            ean_13: '',
            best_before_days: 0,
            private_components: false,
            private_components_text: 'Pokaż tylko moje składniki',
        }
    },
    components: {
        flatPickr,
        'v-select': vSelect
    },
    mounted() {
        if (this.$route.params.id) {
            this.fetchOne(this.$route.params.id);
        }
        this.fetchData();
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser
        },
        isBestBeforeDisabled() {
            return this.isBestBefore;
        },
        converter() {
            let sum = 0;
            let units = {'g': 1, 'kg': 1000, 'l': 1000, 'ml': 1};
            this.productIngredients.forEach(function (item) {
                sum += item.weight * (units[item.unit]);
            });
            return (1 / (sum / 100))
        },
        summarized() {
            let prv = {
                protein: 0,
                carbohydrates: 0,
                fat: 0,
                cholesterol: 0,
                roughage: 0,
                sol: 0
            };

            let units = {'g': 1, 'kg': 1000, 'l': 1000, 'ml': 1};

            this.productIngredients.forEach(function (item) {
                prv.protein += (item.protein * (item.weight * (units[item.unit]) * 0.01));
                prv.carbohydrates += (item.carbohydrates * (item.weight * (units[item.unit]) * 0.01));
                prv.fat += (item.fat * (item.weight * (units[item.unit]) * 0.01));
                prv.cholesterol += (item.cholesterol * (item.weight * (units[item.unit]) * 0.01));
                prv.roughage += (item.roughage * (item.weight * (units[item.unit]) * 0.01));
                prv.sol += (item.sol * (item.weight * (units[item.unit]) * 0.01));
                console.info('SALT', item.sol, item.weight, item.name, item.id);
            });

            prv.protein = (prv.protein * this.converter) || 0;
            prv.carbohydrates = (prv.carbohydrates * this.converter) || 0;
            prv.fat = (prv.fat * this.converter) || 0;
            prv.cholesterol = (prv.cholesterol * this.converter) || 0;
            prv.roughage = (prv.roughage * this.converter) || 0;
            prv.sol = (prv.sol * this.converter) || 0;

            return prv;
        },
    },
    watch: {
        ingredientsPage: function () {
            this.fetchData();
        },
        search: function (a, b) {
            if (!this.isLoading) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.ingredientsPage = 1;
                    this.fetchIngredientsFiltered(a);
                    this.isLoading = true;
                }, 2000);
            }
        },
        ean_8: function () {
            console.log('asjdlsajdlksajkldasj');
        },
        best_before_days: function (value) {
          if(value > 0) {
            this.product.best_before = this.getBestBeforeDays(value);
          }
        },
        'product.best_before': function(newValue, oldValue) {
          if(this.best_before_days > 0 && newValue != this.getBestBeforeDays(this.best_before_days)) {
            this.best_before_days = 0;
          }
        },
        private_components: function (value) {
          this.fetchData();
        },
    },
    methods: {
        isValidEAN13(code) {
          // Ensure it is a string of 13 digits
          if (!/^\d{13}$/.test(code)) return false;

          const digits = code.split('').map(Number);
          const checksum = digits.pop(); // Last digit is the checksum

          const sum = digits.reduce((acc, digit, idx) => {
            return acc + digit * (idx % 2 === 0 ? 1 : 3);
          }, 0);

          const calculatedCheckDigit = (10 - (sum % 10)) % 10;

          return checksum === calculatedCheckDigit;
        },
        getChildrenNames: function (children) {
            let out = [];
            for (let i in children) {
                out.push(children[i].name);
            }
            return out.join(', ');
        },
        fetchData() {
            this.fetchIngredientsFiltered();
        },
        fetchOne(id) {
            let url = process.env.VUE_APP_API_ENDPOINT + '/v1/products/' + id;
            this.$http.get(url).then(response => {
                this.product = response.data.data.product;
                this.productIngredients = response.data.data.ingredients;
                this.pi = response.data.data.ingredients;
                this.isBestBefore = this.product.best_before === null;
            });
        },
        fetchIngredientsFiltered() {

            this.$http.get(process.env.VUE_APP_API_ENDPOINT + '/v1/ingredients?q=' + this.search + '&p=' + this.ingredientsPage + '&filter=' + this.ingredientFilter)
                .then(response => {
                  this.ingredients = response.data.data.ingredients;
                  this.ingredientsCount = Math.ceil(response.data.data.count / 10);
                  //this.ingredientsPage = 1;
                  this.isLoading = false;
                });
        },
        removeIngredient(ingredient) {
            this.productIngredients.splice(ingredient, 1);
        },
        addIngredient(ingredient) {
            this.productIngredients.push(ingredient);
        },
        saveproduct() {
            let postData = {
                product: Object.assign({}, this.product),
                ingredients: Object.assign({}, this.productIngredients)
            };

            postData.product.best_before = this.isBestBefore ? null : this.product.best_before;

            //console.info(postData);
            this.requestObject = {};

            // add
            if (postData.product.id === '' || postData.product.id === null) {
                delete postData.product.id;
                this.requestObject = {
                    url: process.env.VUE_APP_API_ENDPOINT + '/v1/products',
                    method: 'post',
                    data: postData
                }
            } else {
                this.requestObject = {
                    url: process.env.VUE_APP_API_ENDPOINT + '/v1/products/' + postData.product.id,
                    method: 'put',
                    data: postData
                }
            }

            this.$http.request(this.requestObject).then(response => {
                //this.products = response.data.data;
                if (response.data.data === true) {
                    this.$vs.dialog({
                        color: 'success',
                        title: `Wiadomość`,
                        text: 'Produkt został zapisany do Twojej bazy',
                        accept: this.acceptAlert
                    })
                    //  this.resetForm();
                    this.fetchData();
                } else {
                    this.$vs.dialog({
                        color: 'warning',
                        title: `Błąd`,
                        text: 'Wystąpił błąd podczas dodawania składnika. Spróbuj jeszcze raz lub skontaktuj się z administratore,',
                        accept: this.acceptAlert
                    })
                }
            });
        },
        resetForm() {
            for (let i in this.product) {
                this.product[i] = '';
            }
        },
        submitForm() {
            console.log('submit');
            this.$validator.validateAll().then(result => {
                console.log(result);
                if (result) {
                    this.saveproduct();
                }
            })
        },
        toWeight(num) {
            return num.toFixed(2);
        },
      getBestBeforeDays(days){
        let today = new Date();
        today.setDate(today.getDate() + days);
        return today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, '0') + '-' + today.getDate().toString().padStart(2, '0');
      }
    }
}

</script>

